

































import Vue from 'vue'
import CardForm from './CardForm.vue'
import SetPermission from './SetPermission.vue'
import { AppCardServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'

const serviceProxy = new AppCardServiceProxy()

export default Vue.extend({
  name: 'EditCard',
  components: {
    CardForm,
    SetPermission
  },
  props: {
    visible: { // 是否展示
      type: Boolean,
      default: false
    },
    appInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    clientList: {
      type: Array,
      default: () => []
    },
    cardInfo: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      form: this.$form.createForm(this),
      filter: {
        methodName: '',
        url: ''
      },
      activeTab: '1'
    }
  },
  computed: {
    'appId'() {
      const { appInfo }: any = this
      return appInfo && appInfo.id
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.activeTab = '1'
        }
      },
      immediate: true
    },
    cardInfo: {
      handler(val) {
        this.activeTab = '1'
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 提交编辑
    async handleOk() {
      const { handleValidate } = this.$refs.cardForm
      let validateStatus = true
      await handleValidate().then((res: any) => {
        validateStatus = res
      })
      // console.log('validateStatus:', validateStatus)
      if (!validateStatus) {
        return
      }
      this.loading = true
      const { formData }: any = this.$refs.cardForm
      const { avatar, displayName, description, componentKey, edition } = formData
      let params: any = {
        appId: this.appId,
        id: this.cardInfo.id,
        avatar, displayName, description, componentKey, edition
      }
      serviceProxy.updateAppCard(params).then((res: any) => {
        if (res) {
          this.$message.success('page_mdc_setting_edit_success')
          this.$emit('close', true)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 关闭弹出
    handleCancel() {
      this.$emit('close')
    }
  }
})
